var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"text-navy"},[_c('i',{staticClass:"fa fa-play fa-rotate-270",staticStyle:{"height":"10px"}})])])}]

export { render, staticRenderFns }